<template>
    <div class="newsletter-banner dus-container py-lg-64 py-48">
        <div>
            <h4 class="pb-16">{{$t('newsletter-banner.title')}} </h4>
            <span class="guideline-small ">{{$t('newsletter-banner.description')}}</span>
        </div>
        <RenaultButton is-white is-anchor href="/newsletter" is-small :text="$t('newsletter-banner.button')">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M10.5694 3.29858C14.7301 5.38842 18.6049 8.03451 21.9811 11.2476V12.7918C18.5224 15.9046 14.643 18.5158 10.5684 20.7504L9.89074 19.439C13.3662 17.5269 16.6606 15.2996 19.7128 12.7649H1.62109V11.2649H19.7851C16.789 8.6375 13.4616 6.41541 9.90483 4.62143L10.5694 3.29858Z" fill="black"/>
            </svg>
        </RenaultButton>
    </div>
</template>

<script>
import RenaultButton from '../Shared/RenaultButton.vue';
    export default {
        components: {
            RenaultButton,
        },
    }
</script>